import { Button, Flex, IconButton, Modal } from '@homeexchange/design';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import i18n from '../../i18n';
import Analytics from '../../utils/analytics';
import { NAVIGATION_ACTION, NAVIGATION_AREAS, NAVIGATION_TEXT } from '../analytics/analytics-constants';
import useGTM from '../analytics/useGTM';
import HomeFavoriteButton from './HomeFavoriteButton';
import HomeShareButton from './HomeShareButton';
var HomeDisconnectedActions = function (_a) {
    var homeId = _a.homeId, _b = _a.useSigninForContact, useSigninForContact = _b === void 0 ? false : _b, user = _a.user;
    var _c = useState(false), showEllipsisModal = _c[0], setShowEllipsisModal = _c[1];
    var fetchNavigation = useGTM(user).fetchNavigation;
    var handleSignupClick = function (area, text) {
        Analytics.trackGTM('button', fetchNavigation(NAVIGATION_ACTION.CLICK, area, text));
        document.dispatchEvent(new CustomEvent('open_signup_popup'));
    };
    var handleContactClick = function () {
        if (useSigninForContact) {
            document.dispatchEvent(new CustomEvent('open_signin_popup'));
            return;
        }
        handleSignupClick(NAVIGATION_AREAS.USER_PROFILE, NAVIGATION_TEXT.CONTACT_SIGN_UP);
    };
    var handleFavoritesClick = function () {
        handleSignupClick(NAVIGATION_AREAS.DETAILS, NAVIGATION_TEXT.ADD_TO_FAVORITES_SIGN_UP);
    };
    var contactButton = (React.createElement(Button, { size: "large", isFullWidth: true, onClick: handleContactClick }, i18n.t('home:home.view.disconnected.contact')));
    return (React.createElement("div", { className: "contact-button" },
        React.createElement("div", { className: "visible-xs" },
            React.createElement(Flex, { direction: "row", gap: "2", flexWrap: "nowrap", alignItems: "center" },
                React.createElement(IconButton, { icon: "DotsVertical", hierarchy: "secondary", size: "large", onClick: function () { return setShowEllipsisModal(true); }, "aria-label": i18n.t('home:more_options') }),
                contactButton)),
        React.createElement("div", { className: "hidden-xs" },
            React.createElement(Flex, { gap: "4", direction: "column", isFullWidth: true },
                contactButton,
                React.createElement(HomeFavoriteButton, { onClick: handleFavoritesClick }),
                React.createElement(HomeShareButton, { homeId: homeId }))),
        React.createElement(Modal, { isOpen: showEllipsisModal, onClose: function () { return setShowEllipsisModal(false); }, isClosable: true, areDividersVisible: false, size: "small" },
            React.createElement("div", { id: "contact-ellipsis-modal-content" },
                React.createElement(Flex, { gap: "4", direction: "column", isFullWidth: true },
                    React.createElement(HomeFavoriteButton, { onClick: handleFavoritesClick }),
                    React.createElement(HomeShareButton, { homeId: homeId }))))));
};
var mapStateToProps = function (state) { return ({
    user: state.user
}); };
export default connect(mapStateToProps)(HomeDisconnectedActions);
